import { DoqType, ResponsiveDoqWithSpeechBubble } from '@ardoq/doq';
import styled from 'styled-components';
import { colors } from '@ardoq/design-tokens';
import { t } from '@ardoq/i18n';
import { getPreAppI18nLocale } from 'preAppI18nBootstrap';

const Wrapper = styled.div`
  background-color: ${colors.white950};
  border-radius: 20px;
`;

const IPAddressBlockedPage = () => {
  const i18nLocale = getPreAppI18nLocale();
  return (
    <Wrapper>
      <ResponsiveDoqWithSpeechBubble
        title={t(i18nLocale, 'ipAddressBlocked:title', 'Invalid Network')}
        message={
          <p>
            {t(
              i18nLocale,
              'ipAddressBlocked:message',
              "Based on the security settings in your org, it looks like you're accessing us from an invalid network. Please switch networks or, if you're unsure which network to join, please contact your administrator."
            )}
          </p>
        }
        doqType={DoqType.ALARM}
      />
    </Wrapper>
  );
};

export { IPAddressBlockedPage };
